import { createFileRoute } from '@tanstack/react-router';

import { UserConsentForSupportApp } from 'src/apps/userConsentForSupport/app/UserConsentForSupportApp';

export const Route = createFileRoute('/_auth/_layout/data-access-consent')({
  component: () => <UserConsentForSupportApp />,
});
